import React, { useEffect, useRef, useState } from "react";
import {
  EditorState,
  convertFromRaw,
  convertToRaw,
  ContentState,
} from "draft-js";
import { EditorInput } from "../../Components";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function MyProfileAbout({
  form,
  setInput,
  updateForm,
  saveChanges,
  categories,
  categoriesData,
  setBio,
  error,
  setShowConfirmInfModal,
}) {
  const hasInitialized = useRef(false);

  const getInitialContentState = () => {
    if (!form.bio) {
      return ContentState.createFromText("");
    }

    try {
      const parsedBio = JSON.parse(form.bio);
      if (parsedBio.blocks && Array.isArray(parsedBio.blocks)) {
        return convertFromRaw(parsedBio);
      }
      return ContentState.createFromText(
        typeof parsedBio === "string" ? parsedBio : JSON.stringify(parsedBio)
      );
    } catch (error) {
      return ContentState.createFromText(form.bio);
    }
  };

  const [editorState, setEditorState] = useState(() =>
    EditorState.createWithContent(getInitialContentState())
  );

  // useEffect(() => {
  //   const newContentState = getInitialContentState();
  //   setEditorState(EditorState.createWithContent(newContentState));
  // }, [form.bio]);

  // const updateTextDescription = async (state) => {
  //   setEditorState(state);
  //   const contentState = state.getCurrentContent();
  //   const rawContent = convertToRaw(contentState);

  //   if (contentState.hasText()) {
  //     setBio(JSON.stringify(rawContent));
  //   } else {
  //     setBio("");
  //   }
  // };

  useEffect(() => {
    if (!hasInitialized.current && form.bio) {
      const newContentState = getInitialContentState();
      setEditorState(EditorState.createWithContent(newContentState));
      hasInitialized.current = true;
    }
  }, [form.bio]);

  const updateTextDescription = async (state) => {
    setEditorState(state);
    const contentState = state.getCurrentContent();
    const rawContent = convertToRaw(contentState);
    const jsonString = JSON.stringify(rawContent);

    // Only update if content actually changed
    if (contentState.hasText()) {
      if (form.bio !== jsonString) {
        setBio(jsonString);
      }
    } else {
      if (form.bio !== "") {
        setBio("");
      }
    }
  };
  const [searchValue, setSearchValue] = useState("");
  const inputWrapper = useRef(null);
  const inpRef = useRef(null);
  const [list, setList] = useState(categories || []);
  const [focus, setFocus] = useState(false);

  const closeSearch = () => {
    setSearchValue("");
    setFocus(false);
    setList(categories || []);
    if (inpRef.current) {
      inpRef.current.value = "";
      inpRef.current.blur();
    }
  };

  const delCategory = (catId) => {
    setShowConfirmInfModal(true);
    const newCategory = [...(form.categories || [])];
    const index = newCategory.indexOf(catId);
    if (index > -1) {
      newCategory.splice(index, 1);
      updateForm({ categories: newCategory });
    }
  };

  const setCategory = (obj) => {
    setShowConfirmInfModal(true);
    const foundItem = categories?.filter(
      (item) => item.toUpperCase() === obj.value.toUpperCase()
    );

    if (foundItem?.length > 0) {
      const newCategory = [...(form.categories || [])];
      const selCategory = categoriesData?.find(
        (cat) => cat.name.toUpperCase() === obj.value.toUpperCase()
      );

      if (selCategory && !newCategory.includes(selCategory.id)) {
        newCategory.push(selCategory.id);
        updateForm({ categories: newCategory });
      }
      closeSearch();
    }
  };

  const optionClickHandler = (item) => {
    setShowConfirmInfModal(true);
    const newCategory = [...(form.categories || [])];

    if (Array.isArray(categoriesData)) {
      const selCategory = categoriesData.find(
        (cat) => cat.name.toUpperCase() === item.toUpperCase()
      );
      if (selCategory && !newCategory.includes(selCategory.id)) {
        newCategory.push(selCategory.id);
        updateForm({ categories: newCategory });
      }
    }
    closeSearch();
  };

  const searchListFunc = (text) => {
    return (categories || []).filter((item) =>
      item.toUpperCase().includes(text.toUpperCase())
    );
  };

  const handleChange = (event) => {
    setShowConfirmInfModal(true);
    const filteredList = searchListFunc(event.target.value);
    setSearchValue(event.target.value);
    setList(filteredList);
  };

  const handlePress = (event) => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      event.preventDefault();
      setCategory({ value: event.target.value });
      return;
    }
  };

  useEffect(() => {
    if (categories && form.categories && Array.isArray(categoriesData)) {
      let newList = [...categories];
      form.categories.forEach((catId) => {
        const categoryItem = categoriesData.find((item) => item.id === catId);
        if (categoryItem) {
          const index = newList.indexOf(categoryItem.name);
          if (index > -1) {
            newList.splice(index, 1);
          }
        }
      });
      setList(newList);
    }

    const windowClick = ({ target }) => {
      if (inputWrapper.current && !inputWrapper.current.contains(target)) {
        closeSearch();
      }
    };

    if (focus) {
      window.addEventListener("click", windowClick);
    } else {
      window.removeEventListener("click", windowClick);
    }

    return () => window.removeEventListener("click", windowClick);
  }, [focus, form.categories, categories, categoriesData]);

  const getCategoryNames = () => {
    if (!categoriesData || !Array.isArray(categoriesData)) {
      return [];
    }
    return (form.categories || [])
      .map((catId) => {
        const category = categoriesData.find((item) => item.id === catId);
        return category ? category.name : null;
      })
      .filter(Boolean);
  };

  return (
    <div className="space-y-6">
      {/* Bio Editor Section */}
      <div className="bg-green-25">
        <label className="block text-sm font-medium text-green-800 mb-3">
          Bio <span className="text-red-500">*</span>
        </label>
        <div
          className={`border border-green-200 rounded-lg overflow-hidden ${
            error && (!form.bio || form.bio === "") ? "border-red-500" : ""
          }`}
        >
          <EditorInput
            form={form}
            editorState={editorState}
            // label="Bio"
            onEditorStateChange={updateTextDescription}
            // errorText="Please enter Bio"
            isRequired
          />
        </div>
        {error && (!form.bio || form.bio === "") && (
          <p className="text-red-500 text-sm mt-2">Please enter Bio</p>
        )}
      </div>

      {/* Content Category Section */}
      <div className="bg-green-25 rounded-lg p-6 border border-green-100 ">
        <div ref={inputWrapper}>
          <label className="block text-sm font-medium text-green-800 mb-3">
            Content category <span className="text-red-500">*</span>
          </label>

          {/* Selected Categories */}
          <div className="flex flex-wrap gap-2 mb-4">
            {getCategoryNames().map((categoryName, index) => (
              <div
                key={index}
                className="inline-flex items-center gap-2 px-3 py-2 bg-green-500 text-white rounded-full text-sm font-medium"
              >
                {categoryName}
                <button
                  onClick={() => {
                    const category = categoriesData?.find(
                      (item) => item.name === categoryName
                    );
                    if (category) delCategory(category.id);
                  }}
                  className="w-4 h-4 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 flex items-center justify-center transition-all"
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          {/* Search Input */}
          <div>
            <input
              ref={inpRef}
              type="text"
              placeholder="Search and select categories..."
              onChange={handleChange}
              onKeyDown={handlePress}
              onFocus={() => setFocus(true)}
              className={`w-full px-4 py-3 border border-green-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-white  ${
                error && (!form.categories || form.categories.length === 0)
                  ? "border-red-500"
                  : ""
              }`}
            />

            {/* Dropdown Options - Fixed with absolute and z-index */}
            {focus && list.length > 0 && (
              <div className="absolute z-50 w-full mt-1 bg-white border border-green-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                {" "}
                {list.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => optionClickHandler(item)}
                    className="px-4 py-3 hover:bg-green-50 cursor-pointer transition-colors border-b border-green-50 last:border-b-0"
                  >
                    <span className="text-green-900">{item}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {error && (!form.categories || form.categories.length === 0) && (
            <p className="text-red-500 text-sm mt-2">
              Please select Content category
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
